import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { HiMiniBars3 } from "react-icons/hi2";

function TopBar() {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setDropdownVisible(false); // Hide dropdown on larger screens
      }
    };

    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
    };

    window.addEventListener('resize', handleResize);
    document.addEventListener('mousedown', handleClickOutside);
    
    return () => {
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setDropdownVisible(prevState => !prevState);
  };

  const handleItemClick = () => {
    if (isMobile) {
      setDropdownVisible(false);
    }
  };

  const navStyle = {
    backgroundColor: isMobile ? '#1E201E' : '#f8f8f8',
    padding: '10px',
    alignItems: 'center',
    display: 'flex',            // Add this
    justifyContent: isMobile? 'flex-start' : 'center',   // Add this
  };
  
  const ulStyle = {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    display: isMobile ? (dropdownVisible ? 'block' : 'none') : 'flex',
    alignItems: 'center',
    position: isMobile ? 'absolute' : 'static',
    top: isMobile ? '100px' : 'auto',
    left: 0,
    right: 0,
    backgroundColor: isMobile ? '#1E201E' : '#f8f8f8',
    zIndex: 2,
  };

  const liStyle = {
    display: isMobile ? 'block' : 'inline',
    margin: isMobile ? '0' : '0 20px',
    textAlign: 'center',
    position: 'relative',
  };

  const linkStyle = {
    color: isMobile ? 'white' : 'black',
    textDecoration: 'none',
    padding: '6px',
    display: 'block',
    fontSize:'14px',
    fontWeight:'bold'
  };

  return (
    <div style={{ alignItems: 'center' }}>
      <nav style={navStyle}>
        {isMobile && (
          <div 
            onClick={toggleDropdown} 
            style={{ cursor: 'pointer', color: 'white', display: 'flex', alignItems: 'center' }}
          >
            <HiMiniBars3 style={{ marginLeft: '10px', color: 'white', marginBottom: '-3px' }} />
            <span style={linkStyle}>Menu</span>
          </div>
        )}
        <ul ref={dropdownRef} style={ulStyle}>
          <li style={liStyle}>
            <Link to="/mainmasters" style={linkStyle} onClick={handleItemClick}>SCHEDULE</Link>
          </li>
          <li style={liStyle}>
            <Link to="/videoconference" style={linkStyle} onClick={handleItemClick}>APPOINTMENT</Link>
          </li>
        </ul>
      </nav>
    </div>
  );
}

export default TopBar;
